<div class="heading-wrapper">
  <p class="heading">
    {{ 'myAccount.editPreferences' | cxTranslate }}
  </p>
</div>
<ng-container *ngIf="managedPreferences$ | async as data">
  <div class="notification-wrapper">
    <ng-container *ngFor="let enum of data.enums">
      <ng-container *ngIf="myaccountAccountInfo$ | async as myaccount">
        <mat-checkbox
          [checked]="compareValue(enum, this.preferencesCodes)"
          disableRipple
          class="notification-checkbox"
          [color]="'primary'"
          (change)="onChangeEventFunc(enum.code, $event)"
        >
          {{ enum.name }}
        </mat-checkbox>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
<div class="notification-button-wrapper" *ngIf="!this.isMobile">
  <button
    class="btn secondary-btn"
    [routerLink]="
      {
        cxRoute: 'myAccount'
      } | cxUrl
    "
  >
    {{ 'common.cancel' | cxTranslate }}
  </button>
  <button
    class="btn primary-btn"
    [class.disabled]="isBtnDisabled"
    [disabled]="isBtnDisabled"
    (click)="onSubmit($event)"
  >
    {{ 'common.save' | cxTranslate }}
  </button>
</div>
<div class="notification-button-wrapper" *ngIf="this.isMobile">
  <button
    class="btn primary-btn"
    [class.disabled]="isBtnDisabled"
    [disabled]="isBtnDisabled"
    (click)="onSubmit($event)"
  >
    {{ 'common.save' | cxTranslate }}
  </button>
  <button
    class="btn secondary-btn"
    [routerLink]="
      {
        cxRoute: 'myAccount'
      } | cxUrl
    "
  >
    {{ 'common.cancel' | cxTranslate }}
  </button>
</div>
